<template>
  <div class="content-page mobile-app">
    <div class="mian-page">
      <div class="title-page">申请人信息</div>
      <div class="backgroundBox">
        <div class="main-contentBox">
          <div class="re-contentBox">
            <div class="textBox">
              <el-form :model="ruleForm" :label-position="labelPosition" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm search-items">
                <el-form-item label="申请人" prop="loginName" class="col1-2">
                  <el-input placeholder="请输入姓名" v-model.trim="ruleForm.loginName" maxlength="20" :disabled="disabledFields.loginName"></el-input>
                </el-form-item>
                <div class="flexEnd text-width pt15">
                  <div class="tiptext"> （请输入非空格字符或汉字）</div>
                </div>
                <el-form-item label="证件类型" prop="identificationType" disabled class="col1-2">
                  <el-select v-model="ruleForm.identificationType" disabled style="width:100%">
                    <el-option value="1001001" key="1001001" label="身份证"></el-option>
                  </el-select>
                </el-form-item>
                <div class="col1-2"></div>
                <el-form-item label="证件号码" prop="identificationCard" class="col1-2">
                  <el-input placeholder="请输入身份证号码" v-model.trim="ruleForm.identificationCard" maxlength="18" :disabled="disabledFields.identificationCard"></el-input>
                </el-form-item>
                <div class="col1-2"></div>
                <el-form-item label="手机号码" prop="phone" class="col1-2">
                  <el-input placeholder="请输入手机号码" v-model.trim="ruleForm.phone" maxlength="20" :disabled="disabledFields.phone"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="btnLists">
            <div v-no-more-div class="border-btn" @click="goBack">返回上一页</div>
            <div v-no-more-div class="primary-btn" style="margin-left: auto" @click="submitForm('ruleForm')">进入下一页</div>
          </div>
        </div>
      </div>
    </div>
    <faceIdTip ref="faceIdTip" @nextTep="nextTep" />
  </div>
</template>

<script>
import { uuid } from '@/utils';
import Api from '@api/api';
import faceIdTip from '@/components/face/faceIdTip.vue';

const moduleCodeSwitch = () => {
  switch (localStorage.getItem('oprate')) {
    case 'apply':
      return '1';
    case 'search':
      return '2';
    case 'revokeApply':
      return '3';
    default:
      return '1';
  }
};

export default {
  name: 'MobileLogin',
  components: {
    faceIdTip
  },
  data () {
    var validatePhone = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('请输入手机号码'));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };
    var validateName = (rule, value, callback) => {
      if (/\s+/g.test(this.ruleForm.loginName) || value === '') {
        callback(new Error('请输入正确的姓名'));
      } else {
        callback();
      }
    };

    var validateIdCard = (rule, value, callback) => {
      if (!/^[1-9]\d{5}(?:18|19|20|21|22)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/.test(this.ruleForm.identificationCard) || value === '') {
        callback(new Error('请输入正确的证件号码'));
      } else {
        callback();
      }
    };

    return {
      oprate: localStorage.getItem('oprate'),
      ruleForm: {
        identificationCard: '',
        identificationType: '1001001',
        loginName: '',
        phone: ''
      },
      rules: {
        loginName: [
          { required: true, validator: validateName, trigger: 'blur' }
        ],
        identificationType: [
          { required: true, message: '请选择证件类型', trigger: 'blur' }
        ],
        identificationCard: [
          { required: true, validator: validateIdCard, trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ]
      },
      labelPosition: 'left',
      // 自动回填的字段置灰禁用，不允许修改
      disabledFields: {
        loginName: false,
        identificationCard: false,
        phone: false
      }
    };
  },
  mounted () {
    this.fillFromUserInfo();

    if (document.body.clientWidth <= 750) {
      this.labelPosition = 'top';
    } else {
      this.labelPosition = 'left';
    }
    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth <= 750) {
          this.labelPosition = 'top';
        } else {
          this.labelPosition = 'left';
        }
      })();
    };
  },
  activated () {
    // 页面激活时重新读取 userInfo，解决 OAuth 异步回填延迟问题
    // APP 端从 codeSearch 跳转到 login 时，getUserInfo() 可能尚未完成，
    // activated 确保每次进入页面都能读取到最新的 localStorage.userInfo
    this.fillFromUserInfo();
  },
  methods: {
    // 读取 localStorage.userInfo 回填表单
    fillFromUserInfo () {
      const userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        try {
          const user = JSON.parse(userInfo);
          const loginName = user.name || user.loginName || '';
          const identificationCard = user.idcard || user.identificationCard || '';
          const phone = user.mobile || user.phone || '';
          this.ruleForm.loginName = loginName;
          this.ruleForm.identificationCard = identificationCard;
          this.ruleForm.phone = phone;
          // 仅将真正回填了值的字段置灰禁用
          this.disabledFields.loginName = !!loginName;
          this.disabledFields.identificationCard = !!identificationCard;
          this.disabledFields.phone = !!phone;
        } catch (e) {
          console.error('解析 userInfo 失败:', e);
        }
      }
    },
    // 返回上一页
    goBack () {
      this.$router.push({ name: 'MCodeSearch' });
    },
    // 保存登录信息并跳转（用于已注册用户）
    saveLoginInfoAndGoHome (wssqUser) {
      const params = {
        loginName: this.ruleForm.loginName,
        identificationType: this.ruleForm.identificationType,
        identificationCard: this.ruleForm.identificationCard,
        phone: this.ruleForm.phone || '',
        isFace: this.oprate == 'apply' ? 1 : null,
        isToWithdraw: this.oprate == 'revokeApply' ? 1 : null,
        verificationCode: '',
        moduleCode: moduleCodeSwitch(),
        id: '',
        loginText: this.ruleForm.loginName
      };

      Api.saveLoginInfo(params).then((res) => {
        if (res.data.code === '0') {
          // 保存用户信息
          if (wssqUser) {
            localStorage.setItem('wssqUser', JSON.stringify(wssqUser));
          }
          localStorage.setItem('loginIdentificationCard', this.ruleForm.identificationCard);
          localStorage.setItem('loginName', this.ruleForm.loginName);
          localStorage.setItem('applicantInfo', JSON.stringify(this.ruleForm));
          localStorage.setItem('isLogin', 'true');
          localStorage.setItem('isRegistered', 'true');

          // 更新 Vuex 中的登录状态
          this.$store.dispatch('setLoginStatus', {
            userName: this.ruleForm.loginName,
            loginName: this.ruleForm.loginName,
            identificationCard: this.ruleForm.identificationCard,
            phone: this.ruleForm.phone
          });

          this.$toast({
            message: '登录成功',
            type: 'success'
          });

          // 跳转到 mobile 端的 codeSearch 页面
          setTimeout(() => {
            this.$router.push({ name: 'MCodeSearch' });
          }, 1000);
        } else {
          this.$toast({
            message: res.data.msg || '登录失败，请重试',
            duration: 4000
          });
        }
      }).catch((err) => {
        console.log('saveLoginInfo error', err);
        this.$toast({
          message: '登录失败，请重试',
          duration: 4000
        });
      });
    },
    // 检查用户是否已注册
    checkUserExist () {
      const { identificationCard, phone } = this.ruleForm;

      Api.checkUserExistByPhoneAndIdentificationCard(identificationCard, phone)
        .then((res) => {
          const state = res.data?.data?.state;
          console.log('checkUserExist res', res);

          if (state == 0) {
            // 未注册，跳转到身份验证页面
            this.$toast({
              message: '识别到未注册，请先注册',
              duration: 2000
            });
            setTimeout(() => {
              // 保存到 store
              this.$store.dispatch('setLoginStatus', {
                userName: this.ruleForm.loginName,
                loginName: this.ruleForm.loginName,
                identificationCard: this.ruleForm.identificationCard,
                phone: phone
              });
              this.$router.push({ name: 'MAuth' });
            }, 500);
          } else if (state == 1) {
            // 已注册（身份证一致），调用登录接口并传递用户信息
            const wssqUser = res.data?.data?.wssqUser;
            this.saveLoginInfoAndGoHome(wssqUser);
          } else if (state == 2) {
            // 已注册（身份证不一致），跳转到 m-codeSearch 页面并显示弹窗
            this.$router.push({
              name: 'MCodeSearch',
              query: {
                showRegestStatusDialog: 'true'
              }
            });
          } else {
            // 其他情况，跳转到身份验证页面
            this.$toast({
              message: '未识别到注册信息，请先注册',
              duration: 2000
            });
            setTimeout(() => {
              // 保存到 store
              this.$store.dispatch('setLoginStatus', {
                userName: this.ruleForm.loginName,
                loginName: this.ruleForm.loginName,
                identificationCard: this.ruleForm.identificationCard,
                phone: phone
              });
              this.$router.push({ name: 'MAuth' });
            }, 500);
          }
        })
        .catch((err) => {
          console.log('checkUserExist error', err);
          this.$toast({
            message: '检查用户状态失败，请重试',
            duration: 2000
          });
          // 接口调用失败，跳转到身份验证页面
          setTimeout(() => {
            // 保存到 store
            this.$store.dispatch('setLoginStatus', {
              userName: this.ruleForm.loginName,
              loginName: this.ruleForm.loginName,
              identificationCard: this.ruleForm.identificationCard,
              phone: phone || ''
            });
            this.$router.push({ name: 'MAuth' });
          }, 1000);
        });
    },
    nextTep () {
      // 人脸识别成功后，先检查用户是否已注册
      this.checkUserExist();
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 存储申请人信息到 localStorage
          localStorage.setItem('applicantInfo', JSON.stringify(this.ruleForm));
          // 保存到 store，供 auth 页面使用
          this.$store.dispatch('setLoginStatus', {
            userName: this.ruleForm.loginName,
            loginName: this.ruleForm.loginName,
            identificationCard: this.ruleForm.identificationCard,
            phone: this.ruleForm.phone
          });
          // 随申办不用走人脸识别逻辑，直接下一步
          this.nextTep();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.main-contentBox {
  padding: 16px;
  height: auto;
  .re-contentBox {
    overflow: auto;
    min-height: 380px;
    background: rgba(255, 255, 255, 0.05);
    box-shadow: 2px 6px 10px 0px rgba(128, 126, 189, 0.24);
    border-radius: 8px;
    backdrop-filter: blur(20px);
    display: flex;
    align-items: center;
    justify-content: center;
    .textBox {
      width: 100%;
      padding: 16px;
      .tiptext {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #999999;
        line-height: 37px;
        margin-left: 5px;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .main-contentBox {
    padding: 16px;
  }
  .tiptext {
    font-size: 12px !important;
  }
  .el-input {
    font-size: 12px !important;
  }
}

@media screen and (max-width: 750px) {
  .main-contentBox {
    padding: 16px;
  }

  .main-contentBox .re-contentBox {
    backdrop-filter: none;
  }
  .re-contentBox {
    padding: 16px;
    .el-form-item__content {
      margin-bottom: 0 !important;
      margin-left: 10px !important;
    }
    ::v-deep .el-form-item__label {
      padding: 0px !important;
    }
    .flexEnd {
      display: flex;
      align-items: center;
    }
    .text-width {
      width: 100%;
    }
    .pt10 {
      padding-top: 10px;
    }
    .pt15 {
      padding-top: 15px;
    }
  }
}

.el-form-item {
  width: 100%;
  margin-bottom: 0 !important;
}

@media screen and (max-width: 500px) {
  .main-contentBox {
    padding: 16px;
  }
  .re-contentBox {
    .text-width {
      width: 100% !important;
      padding-top: 0 !important;
    }
    .el-form-item {
      width: 100%;
      margin-bottom: 0 !important;
    }
    ::v-deep .el-form-item__error {
      position: static !important;
    }
    .pt10 {
      padding-top: 36px !important;
    }
  }
}

@media screen and (max-width: 300px) {
  .el-form-item {
    width: 100%;
  }
  .re-contentBox .pt10 {
    padding-top: 10px !important;
  }
}

</style>
